//base
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
//components
import Button from "../../shared/Button";
import Login from "../Login/Login";

//images
import Counter from "../../shared/Counter";

function Hero({
  signUpRef,
  isLoginOpen,
  setLoginOpen,
  isLogin,
  setIsLogin,
  menuHandler
}) {
  const [width, setWidth] = useState(window.innerWidth);
  const { sample_tuesday_date } = useSelector(state => state.landing);
  console.log(useSelector(state => state.landing));

  const version = window.location.pathname === "/landing" ? 1 : 2;

  useEffect(() => {
    if (!isLoginOpen) return;

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [isLoginOpen]);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
  }, [window, width]);

  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    if (params.get("signup") == "open" || window.location.pathname=="/signup") {
      adjustBackground();
      menuHandler(false);
    }
  }, []);

  useEffect(()=> {
    if (window.location.pathname=="/login")
      menuHandler(true);
  }, []);

  function adjustBackground() {
    var element = document.getElementsByClassName(
      "pw-hero-container--image-container"
    )[0];
    element.classList.toggle("toggle-contain");
  }

  function HeroSecondVersion() {
    return (
      <>
        <h4 className={"new-samples"} id={"#unauth-home-samples"}>
          New Samples Released {sample_tuesday_date}
        </h4>
        <div ref={signUpRef} className="pw-hero-container">
          <div className="pw-hero-container--image-container">
            {isLoginOpen ? (
              <Login
                isLogin={isLogin}
                setIsLogin={setIsLogin}
                close={() => {
                  adjustBackground();
                  setLoginOpen(false);
                }}
              />
            ) : (
              <div className="pw-hero-container--info-container version-2-container">
                <h1 className="pw-hero-container--title version-2-title">
                  We send you free samples. You tell us what you think.
                </h1>
                <p className="pw-hero-container--subtitle">
                  No catch, no credit card required!
                </p>
                <Button
                  onClick={() => {
                    adjustBackground();
                    menuHandler(false);
                  }}
                  minWidth="55%"
                  label="LET'S GET STARTED"
                  type="outline"
                  className={"start-button"}
                />
                <p className="pw-hero-container--signin-title">
                  Already have an account?{" "}
                  <span
                    onClick={() => menuHandler(true)}
                    className="pw-hero-container--signin-title__inner"
                  >
                    Sign in
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  function HeroFirstVersion() {
    return (
      <div ref={signUpRef} className="pw-hero-container">
        <div className="pw-hero-container--image-container">
          {isLoginOpen ? (
            <Login
              isLogin={isLogin}
              setIsLogin={setIsLogin}
              close={() => setLoginOpen(false)}
            />
          ) : (
            <div className="pw-hero-container--info-container">
              <h1 className="pw-hero-container--title">
                Join a trusted community of
              </h1>
              <Counter className="pw-hero-container--number" />
              <p className="pw-hero-container--subtitle">
                with over <b>25,000,000 free products</b> shipped to our
                PINCHers!
                <br />
                <br />
                Start PINCHing today!
              </p>
              <Button
                onClick={() => menuHandler(false)}
                minWidth="55%"
                label="LET'S GET STARTED"
                type="outline"
                className={"start-button"}
              />
              <p className="pw-hero-container--signin-title">
                Already have an account?{" "}
                <span
                  onClick={() => menuHandler(true)}
                  className="pw-hero-container--signin-title__inner"
                >
                  Sign in
                </span>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }

  return <div>{version == 2 ? HeroSecondVersion() : HeroFirstVersion()}</div>;
}

export default Hero;

Hero.propTypes = {
  signUpRef: PropTypes.object,
  isLoginOpen: PropTypes.bool,
  setLoginOpen: PropTypes.func,
  isLogin: PropTypes.bool,
  setIsLogin: PropTypes.func,
  menuHandler: PropTypes.func
};
